import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../core/palette"

export const useStyles = makeStyles()(({ palette }) => ({
  selectedDisabled: {
    "& rect": {
      fill: lightBlue[200],
      stroke: lightBlue[200]
    }
  },
  unselectedDisabled: {
    "& rect": {
      stroke: blueGrey[200]
    }
  },
  unselectedNotDisabled: {
    "& rect": {
      stroke: blueGrey[400]
    }
  },
  focused: {
    backgroundColor: "transparent !important",
    "& .MuiTouchRipple-root": {
      display: "none"
    },
    "& rect": {
      stroke: `${palette.focus} !important`,
      strokeWidth: 2
    }
  }
}))
